var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4230_2295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6626 10.8699C20.6626 10.1702 20.6059 9.46668 20.4848 8.77832H10.7759V12.7421H16.3357C16.105 14.0205 15.3637 15.1514 14.2782 15.87V18.4419H17.5952C19.5431 16.6491 20.6626 14.0016 20.6626 10.8699Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7759 20.9268C13.552 20.9268 15.8932 20.0153 17.599 18.4419L14.282 15.87C13.3591 16.4979 12.1677 16.8534 10.7796 16.8534C8.09427 16.8534 5.81738 15.0417 5.00042 12.606H1.57751V15.2573C3.3249 18.7331 6.88397 20.9268 10.7759 20.9268Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99662 12.6061C4.56545 11.3277 4.56545 9.94339 4.99662 8.665V6.01367H1.5775C0.11756 8.9222 0.11756 12.3489 1.5775 15.2574L4.99662 12.6061Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7759 4.41362C12.2434 4.39092 13.6617 4.94313 14.7245 5.95676L17.6633 3.01798C15.8024 1.2706 13.3326 0.309913 10.7759 0.340171C6.88396 0.340171 3.3249 2.53386 1.57751 6.01349L4.99664 8.66483C5.80981 6.2253 8.09049 4.41362 10.7759 4.41362Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4230_2295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.5866,
    height: 20.5866,
    fill: "white",
    transform: "translate(0.276733 0.339355)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.4c4a8dd511a339001eeca0c4f8753cda.svg";
export { ForwardRef as ReactComponent };